// Последний человек, которого открывали во вкладке «Расчёт сотрудника».
//
// Зачем. Расчёт просят считать в паре с другой работой: табельщик сдаёт часы, финансовый отдел
// создаёт ведомость, и человек идёт из документа в «Ведомости» или «Табель», а потом возвращается.
// В программе нет кнопки «назад», а вкладка при переключении отбор не переносит (вкладки раздела
// независимы), поэтому без этой памяти возврат означал бы выбирать человека заново.
//
// Запоминается только непрозрачный идентификатор и только на время сеанса: имя человека вкладка
// достаёт запросом с проверкой прав, так что чужой человек под другим входом по этой записи не
// показывается.

const КЛЮЧ = 'bark.расчёт-сотрудника.последний';

export function запомнитьЧеловека(id: string): void {
  try {
    window.sessionStorage.setItem(КЛЮЧ, id);
  } catch {
    // Хранилище закрыто (приватный режим, переполнено): память — удобство, а не условие работы.
  }
}

export function вспомнитьЧеловека(): string | null {
  try {
    const значение = window.sessionStorage.getItem(КЛЮЧ);
    return значение === null || значение === '' ? null : значение;
  } catch {
    return null;
  }
}
